import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: 'Φόρτωση {{label}}…',
  forbidden: 'Δεν επιτρέπεται να δείτε {{label}}.',
  notFound: 'Δεν ήταν δυνατή η εύρεση {{label}}.',
  loadingFailed: 'Η φόρτωση απέτυχε {{label}}: {{message}}',
  submitForbidden: 'Δεν επιτρέπεται να το κάνετε αυτό{{suffix}}',
  submitConflict: 'Αυτό συγκρούεται με την τρέχουσα κατάσταση{{suffix}}',
  submitGeneric: 'Κάτι πήγε στραβά: {{message}}',
};
